import React, { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [burgerActive, setBurgerActive] = useState(false); // to manage burger menu toggle

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrolled]);

    return (
        <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <a href="/">
                <img src="/hero/logo.svg" alt="Logo" className="navbar-logo" />
            </a>
            <div className={`burger ${burgerActive ? 'active' : ''}`} onClick={() => setBurgerActive(!burgerActive)}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <ul className={`navbar-links ${burgerActive ? 'active' : ''}`}>
                <li><a href="#about" onClick={() => setBurgerActive(false)}>\\sobre</a></li>
                <li><a href="#work" onClick={() => setBurgerActive(false)}>\\nuestro trabajo</a></li>
                <li><a href="#contact" onClick={() => setBurgerActive(false)}>\\contacto</a></li>
            </ul>
        </div>
    );
}

export default Navbar;
